// extracted by mini-css-extract-plugin
export default {"form":"Review_form__a6e+i"};